// Wrapper component for teaser screens.
import { Pad } from 'component/basics';
import type { PropsWithChildren } from 'react';
import type { LayoutChangeEvent } from 'react-native';
import { StyleSheet, View } from 'react-native';

export function onLayout(e: LayoutChangeEvent) {
    const { height } = e.nativeEvent.layout;
    window.parent.postMessage({ type: 'psi-teaser-height', height }, '*');
}

export type TeaserScreenProps = { color?: string };

export function TeaserScreen({ children, color = 'transparent' }: PropsWithChildren<TeaserScreenProps>) {
    const hasEmulateWarning = window.location.hostname == 'localhost';
    return (
        <View onLayout={onLayout} style={[TeaserScreenStyle.teaser, { backgroundColor: color }]}>
            {children}
            {hasEmulateWarning && <Pad size={20} />}
        </View>
    );
}

export const TeaserScreenStyle = StyleSheet.create({
    teaser: {
        borderRadius: 8,
        maxWidth: 797,
        width: '100%',
    },
});
